import { Component, OnInit, Injector } from '@angular/core';

import { WkCustomFilesComponent } from '../../forked/components/wk-custom-files/wk-custom-files.component';
import { WkAppConfigService } from '../../services/wk-app-config.service';
import { ContentActionRef } from '@alfresco/adf-extensions';

@Component({
  templateUrl: './custom-files.component.html',
  styleUrls: ['custom-files.component.scss'],
  standalone: false,
})
export class CustomFilesComponent
  extends WkCustomFilesComponent
  implements OnInit
{
  private readonly appConfigService: WkAppConfigService;
  public readonly infoDrawerComponentId: string;
  constructor(injector: Injector) {
    super(injector);
    this.appConfigService =
      injector.get<WkAppConfigService>(WkAppConfigService);
    this.infoDrawerComponentId = this.appConfigService.get<string>(
      'default-info-drawer'
    );
  }

  public customNavigateTo(event: any): void {
    this.navigateTo(event.detail?.node);
  }

  public trackByActionId(_: number, action: ContentActionRef): string {
    return action.id;
  }

  /**
   * Refresh document list
   * @public
   * @returns { void }
   */
  public refresh(): void {
    this.wkDocumentList.reload();
  }
}
